export const ADD_TAG_ENDPOINT = '/api/tags/add'
export const UPDATE_TAG_ENDPOINT = '/api/tags/update'
export const DELETE_TAG_ENDPOINT = '/api/tags/delete'
export const GET_TAG_ENDPOINT = '/api/tags/get'
export const GET_TAGS_ENDPOINT = '/api/tags/all'
export const GET_TAGS_MANAGERS_ENDPOINT = '/api/tags/managers'
export const GET_TAGS_EMPLOYEES_ENDPOINT = '/api/tags/employees'
export const ACTIVATE_TAG_ENDPOINT = '/api/tags/Activate'
export const DELETED_TAGS = '/api/tags/deleted'



// WEBPACK FOOTER //
// ./src/api/tags/types.js